﻿'use strict';

angular.module('ntmApp')
    .run(['formlyConfig', 'formlyValidationMessages', function (formlyConfig, formlyValidationMessages) {

        var attributes = [
          'date-disabled',
          'custom-class',
          'show-weeks',
          'starting-day',
          'init-date',
          'min-mode',
          'max-mode',
          'format-day',
          'format-month',
          'format-year',
          'format-day-header',
          'format-day-title',
          'format-month-title',
          'year-range',
          'shortcut-propagation',
          'datepicker-popup',
          'show-button-bar',
          'current-text',
          'clear-text',
          'close-text',
          'close-on-date-selection',
          'datepicker-append-to-body',
           'meridians',
          'readonly-input',
          'mousewheel',
          'arrowkeys'
        ];

        var bindings = [
          'datepicker-mode',
          'min-date',
          'max-date',
          'hour-step',
          'minute-step',
          'show-meridian'
        ];

        var getToolTipTemplate = function () {
            var nsPopoverOptions = 'ns-popover="" ns-popover-template="{{ to.label + "_lbl"}}" ns-popover-trigger="mouseenter" ns-popover-theme="ns-popover-tooltip-theme ns-popover-eSirius-theme" ns-popover-placement="top|right" ns-popover-timeout="0"';

            var scriptTemplate = '<script type="text/ng-template" id="{{ to.label + "_lbl"}}">' +
                                 '<div class="triangle"> </div>' +
                                 '<div class="ns-popover-tooltip" ng-bind-html="to.cluetip">' +
                                 '</div>' +
                                 '</script>';

            var template = '<formly-transclude></formly-transclude><a ng-show="to.cluetip"' + nsPopoverOptions +
                           ' class="cluetip question-circle-cluetip"><i class="fa fa-question-circle" aria-hidden="true"></i></a>' + scriptTemplate;
            return template;
        };

        var ngModelAttrs = {};

        angular.forEach(attributes, function (attr) {
            ngModelAttrs[camelize(attr)] = { attribute: attr };
        });

        angular.forEach(bindings, function (binding) {
            ngModelAttrs[camelize(binding)] = { bound: binding };
        });

        function camelize(string) {
            string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
                return chr ? chr.toUpperCase() : '';
            });
            // Ensure 1st char is always lowercase
            return string.replace(/^([A-Z])/, function (match, chr) {
                return chr ? chr.toLowerCase() : '';
            });
        }
        // start formlyConfig section

        formlyConfig.extras.removeChromeAutoComplete = true;
        formlyConfig.extras.ngModelAttrsManipulatorPreferUnbound = true;

        formlyConfig.setWrapper(
        {
            name: 'labelHtml',
            template: [
              '<div>',
                '<label for="{{id}}" class="control-label {{to.labelSrOnly ? \'sr-only\' : \'\'}}" ng-if="to.label">',
                  '{{to.label}}',
                  '<span>{{to.required ? \'*\' : \'\'}}</span>',
                '</label>',
                '<formly-transclude></formly-transclude>',
              '</div>'
            ].join(' ')
        });

        formlyConfig.setType({
            name: 'inputType',
            extends: 'input',
            wrapper: ['labelHtml', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'textareaType',
            extends: 'textarea',
            wrapper: ['labelHtml', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'selectType',
            extends: 'select',
            wrapper: ['labelHtml', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'tinymce',
            template: '<textarea ui-tinymce="to.options" ng-model="model[options.key]"></textarea>',
            wrapper: ['labelHtml', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'typeahead',
            template: '<input type="text" autocomplete="off" ng-model="model[options.key]" uib-typeahead="item[to.displayField] for item in to.getOptions($viewValue) | limitTo:30" typeahead-on-select="to.onSelect($item)" class="form-control" typeahead-template-url="ng1/src/directives/templates/typeaheadItem.html">',
            wrapper: ['labelHtml', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'iconpicker',
            template: '<icon-picker ng-model="model[options.key]" model-is-changed-callback="to.modelIsChangedCallback" model-is-not-changed-callback="to.modelIsNotChangedCallback"></icon-picker>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'radioboolean',
            template: '<md-radio-group ng-model="model[options.key]"><md-radio-button value="Yes" ng-disabled="to.disabled" class="md-primary"> Yes </md-radio-button><md-radio-button ng-disabled="to.disabled" value="No"> No </md-radio-button></md-radio-group>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'colorpicker',
            template: '<color-picker ng-model="model[options.key]" options="to.options"></color-picker>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'textareaWithHtmlBindings',
            template: '<div ng-bind-html="model[options.key]" class="custom-textarea"></div>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'customListbox',
            template: '<div><custom-listbox value="model[options.key]" color="model.Status_Color_" data="to.options" callback="to.callback" class="modal-lisbox" select-first=true></custom-listbox></div>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'datepicker',
            templateUrl: 'ng1/src/templates/datepicker.html',
            wrapper: ['labelHtml', 'bootstrapHasError'],
            defaultOptions: {
                className: 'float-to-left',
                ngModelAttrs: ngModelAttrs,
                templateOptions: {
                    datepickerOptions: {
                        format: 'MM/dd/yyyy',
                        initDate: new Date()
                    }
                }
            },
            controller: ['$scope', function ($scope) {
                $scope.datepicker = {};

                $scope.datepicker.opened = false;

                $scope.datepicker.open = function () {
                    $scope.datepicker.opened = !$scope.datepicker.opened;
                };
            }]
        });

        formlyConfig.setType({
            name: 'timepicker',
            template: '<time-picker model="model[options.key]" class="time-picker-control" hour-step="to.hstep" minute-step="to.mstep" show-meridian="to.showMeridian" disabled="to.disabled" required="to.required"></time-picker>',
            wrapper: ['labelHtml', 'bootstrapHasError'],
            defaultOptions: {
                ngModelAttrs: ngModelAttrs,
                templateOptions: {
                    datepickerOptions: {}
                }
            }
        });

        formlyConfig.setType({
            name: 'formattedNumber',
            wrapper: ['bootstrapLabel', 'bootstrapHasError'],
            template: '<input type="number" ng-model="model[options.key]" class="form-control">'
        });

        formlyConfig.setType({
            name: 'ui-select-multiple',
            extends: 'select',
            template: '<div class="multiselect-form-control" ng-dropdown-multiselect="" options="to.options" events="to.events" translation-texts="to.settings" ng-dropdown-multiselect-disabled="to.disabled" extra-settings="to.extra" selected-model="model[options.key]" checkboxes="false" group-by="{{to.groupBy}}"></div>',
            wrapper: ['labelHtml', 'bootstrapHasError'],
        });

        formlyConfig.setType({
            name: 'dataCollection',
            template: '<div>{{model[options.key]}} <a class="open-dialog-link" ng-click="to.openDialog()">{{model[options.key] ? "Edit" : "Add data collection"}}</a></div>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError']
        });

        formlyConfig.setType({
            name: 'durationSplit',
            template: '<hms-edit-inputs class="duration-split" duration="model[options.key]" disabled="to.disabled" on-change="to.durationChanged()" hide-seconds="to.hideSeconds"></hms-edit-inputs>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError']
        });

        formlyConfig.setWrapper({
            name: 'toolTipWrapper',
            template: getToolTipTemplate()
        });

        formlyValidationMessages.addStringMessage('required', 'This field is required');
        // end formlyConfig section

    }]);